import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import React, { useRef } from 'react';
import RichTextEditor from '../form/RichTextEditor';
import AttachmentToolbar from './AttachmentToolbar';
import VariablesToolbar from './VariablesToolbar';
import useVariables from './useVariables';

const EmailComposer = ({
  id,
  message,
  onChange,
  onFileSelect,
  placeholder,
  onQuickReplySelect,
  ...rest
}) => {
  const editor = useRef();
  const { variablesMap, loading, options: variables } = useVariables();
  const onLinkSelect = (link) => {
    editor.current.editor.execCommand(
      'mceInsertContent',
      false,
      `<a target='_blank' href='${link.url}'>${link.url}</a>&nbsp;`,
    );
    setTimeout(() => {
      editor.current.editor.focus();
    }, 0); // required for focus to work
  };

  const onVariableSelect = (variable) => {
    editor.current.editor.execCommand('insertVariable', false, variable);
  };

  return (
    <Box mt={2} mb={1}>
      <RichTextEditor
        margin="none"
        id={id}
        innerRef={editor}
        value={message}
        onChange={onChange}
        placeholder={placeholder}
        variables={variablesMap}
        {...rest}
      />
      <Stack
        direction="row"
        spacing={1}
        sx={{
          bgcolor: 'background.paper4',
          border: 1,
          borderColor: 'dividerVariant',
          px: 0.5,
          pb: 0.5,
          pt: 1.5,
          mt: -1,
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
        }}
      >
        <VariablesToolbar
          loading={loading}
          variables={variables}
          onSelect={onVariableSelect}
        />
        <AttachmentToolbar
          type="email"
          onLinkSelect={onLinkSelect}
          onFileSelect={onFileSelect}
          onQuickReplySelect={onQuickReplySelect}
        />
      </Stack>
    </Box>
  );
};

export default EmailComposer;
